import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const Navbar = ({ toggleSidebar }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // toggle theme
  const toggleTheme = () => {
    document.documentElement.classList.toggle("dark");
  };

  return (
    <header className="navbar">
      <button className="hamburger" onClick={toggleSidebar}>☰</button>
      <h1 className="page-title">Dashboard</h1>

      <div className="nav-actions" ref={menuRef}>
      <Link to="/receipts" className="btn ghost receipts-btn">
      <span className="receipts-text">Receipts / Bills Summary</span>
      </Link>
        
        <button className="btn ghost" onClick={toggleTheme}>🌙 / ☀️</button>

        {/* Profile Avatar */}
        <div
          className="avatar"
          title="You"
          onClick={() => setMenuOpen(prev => !prev)}
        >
          MK
        </div>

        {/* Dropdown Menu */}
        {menuOpen && (
          <ul className="profile-dropdown">
            <li>Edit Profile</li>
            <li>Manage Account</li>
            <li>Settings</li>
            <li>Privacy</li>
            <li>Help & Support</li>
            <li>Log Out</li>
          </ul>
        )}
      </div>
    </header>
  );
};

export default Navbar;
